"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const login2FAAction_1 = require("@/features/login2fa/actions/login2FAAction");
const login2FAApi_1 = require("../apis/login2FAApi");
const types_1 = require("../types");
const login2FASelector_1 = require("../selectors/login2FASelector");
const constants_1 = require("../constants");
const transaction_signing_store_1 = require("@/store/transaction-signing-store");
function* handleToggleCloseOneToken() {
    yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
}
function* handleToggleResendNotification() {
    yield (0, effects_1.put)((0, login2FAAction_1.endAuthorizationStatus)());
    yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.ONE_TOKEN_WITH_FOOTER));
    const { authorizationId, authorizationTypeCode } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const params = {
        authorizationId,
        authorizationTypeCode
    };
    const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const headers = {
        'x-acc-op': inputData.input.accessToken
    };
    const respsonseWrapper = yield (0, effects_1.call)(login2FAApi_1.apiMfaSendOtpWrapper, params, headers);
    if (respsonseWrapper.isError || respsonseWrapper.data.status !== 'SUCCESS') {
        console.error('handleToggleResendNotification, send mfa-otp error, ignore !!');
    }
    else {
        yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationId)(respsonseWrapper.data.data.authorizationId));
        yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationReference)(respsonseWrapper.data.data.authorizationReference));
        yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationTypeCode)(respsonseWrapper.data.data.authorizationTypeCode));
        yield (0, effects_1.put)((0, login2FAAction_1.setTransactionId)(respsonseWrapper.data.data.transactionId));
    }
    // yield put(startAuthorizationStatus());
}
function* handleToggleGenerateOtp() {
    yield (0, effects_1.put)((0, login2FAAction_1.endAuthorizationStatus)());
    yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.OTP));
    const { authorizationId } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const params = {
        authorizationId,
        authorizationTypeCode: 'SWK_MANUAL'
    };
    const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const headers = {
        'x-acc-op': inputData.input.accessToken
    };
    const responseWrapper = yield (0, effects_1.call)(login2FAApi_1.apiMfaSendOtpWrapper, params, headers);
    if (responseWrapper.isError || responseWrapper.data.status !== 'SUCCESS') {
        console.error('mfa-send-otp failed');
        // yield put(dismissLogin2FA());
        // yield put(cancel2FAWorkFlow(WORKFLOW_CANCEL_REASON.API_ERROR));
    }
    else {
        yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationId)(responseWrapper.data.data.authorizationId));
        yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationReference)(responseWrapper.data.data.authorizationReference));
        yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationTypeCode)(responseWrapper.data.data.authorizationTypeCode));
        yield (0, effects_1.put)((0, login2FAAction_1.setTransactionId)(responseWrapper.data.data.transactionId));
    }
}
function* handleToggleCloseOtp() {
    yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
}
function getLogin2faPopupData(errorCode) {
    switch (errorCode) {
        case constants_1.ACCESS_ELEVATION_VALIDATE_ERROR_CODE.WRONG_OTP:
            return {
                show: true,
                titleId: 'login-2fa-otp-invalid-otp-title',
                contentId: 'login-2fa-otp-invalid-otp-content',
                toggleTopRightCancel: () => {
                    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.toggleCloseInvalid)(true));
                },
                footerType: '1',
                rightBtnLabelId: 'login-2fa-otp-invalid-otp-btn-ok',
                rightBtnCallback: () => {
                    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.toggleCloseInvalid)(false));
                }
            };
        case constants_1.ACCESS_ELEVATION_VALIDATE_ERROR_CODE.EXCEED_MAXIMUM_RETRY:
            return {
                show: true,
                titleId: 'login-2fa-otp-popup-too-many-retries-title',
                contentId: 'login-2fa-otp-popup-too-many-retries-content',
                toggleTopRightCancel: () => {
                    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.toggleCloseInvalid)(true));
                },
                footerType: '2',
                leftBtnLabelId: 'login-2fa-otp-popup-too-many-retries-btn-left-label',
                leftBtnCallback: () => {
                    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.toggleCloseInvalid)(true));
                },
                rightBtnLabelId: 'login-2fa-otp-popup-too-many-retries-btn-right-label',
                rightBtnCallback: () => {
                    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.EXCEED_2FA_OTP));
                }
            };
        default:
        // fallback to none
    }
    return null; //sqfix
}
function* handleToggleSubmitOtp() {
    console.log('handleToggleSubmitOtp');
    const { otpCode, authorizationId, authorizationReference } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const params = {
        authorizationId,
        authorizationReference,
        otp: otpCode
    };
    const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const headers = {
        'x-acc-op': inputData.input.accessToken
    };
    const responseWrapper = yield (0, effects_1.call)(login2FAApi_1.apiAccessElevationvValidateWrapper, params, headers);
    if (responseWrapper.isError) {
        yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
        yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.API_ERROR));
        // yield put(setLayoutStatus(LayoutStatus.VERIFY_SUCCESS));
        // yield delay(2000);
        // yield put(dismissLogin2FA());
        // yield put(end2FAWorkFlowSuccessfully());
    }
    else if (responseWrapper.data.status === constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_SUCCESS) {
        yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.VERIFY_SUCCESS));
        yield (0, effects_1.delay)(2000);
        yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
        yield (0, effects_1.put)((0, login2FAAction_1.end2FAWorkFlowSuccessfully)());
    }
    else if (responseWrapper.data.status === constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED) {
        if (responseWrapper.data.errorCode) {
            switch (responseWrapper.data.errorCode) {
                case constants_1.ACCESS_ELEVATION_VALIDATE_ERROR_CODE.WRONG_OTP:
                    yield (0, effects_1.put)((0, login2FAAction_1.setLogin2faPopupData)(getLogin2faPopupData(responseWrapper.data.errorCode)));
                    break;
                case constants_1.ACCESS_ELEVATION_VALIDATE_ERROR_CODE.EXCEED_MAXIMUM_RETRY:
                    yield (0, effects_1.put)((0, login2FAAction_1.setLogin2faPopupData)(getLogin2faPopupData(responseWrapper.data.errorCode)));
                    break;
                default:
                    yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
                    yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.API_ERROR));
                    break;
            }
        }
        else {
            yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
            yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.API_ERROR));
        }
    }
}
function* handleToggleSubmitHradWareToken() {
    console.log('handleToggleSubmitHradWareToken start :');
    const { otpCode, inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    const { orgId } = inputData.input;
    const { userId } = inputData.input;
    const attr = {
        orgId,
        userId,
        authType: 'pwd',
        isBindHardToken: 'Y',
        tokenGenerateNo: otpCode,
        transactionId: '',
        authorizationId: ''
    };
    const headers = {
        'x-acc-op': inputData.input.accessToken
    };
    const responseWrapper = yield (0, effects_1.call)(login2FAApi_1.apiAccesHardWareSubmitWrapper, attr, headers);
    if (responseWrapper.isError) {
        yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
        yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.API_ERROR));
    }
    else if (responseWrapper.data.body === constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_SUCCESS) {
        yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.VERIFY_SUCCESS));
        yield (0, effects_1.delay)(2000);
        yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
        yield (0, effects_1.put)((0, login2FAAction_1.end2FAWorkFlowSuccessfully)());
    }
}
function* handleToggleMobilePhone() {
    let sqFix;
    yield sqFix;
    console.log('handleToggleMobilePhone');
    window.alert('we are under construction');
}
function* handleToggleCloseInvalid({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
    }
    else {
        yield (0, effects_1.put)((0, login2FAAction_1.setLogin2faPopupData)({
            show: false,
            titleId: '',
            contentId: '',
            toggleTopRightCancel: () => { },
            footerType: '1',
            leftBtnLabelId: '',
            leftBtnCallback: () => { },
            rightBtnLabelId: '',
            rightBtnCallback: () => { }
        }));
        yield (0, effects_1.put)((0, login2FAAction_1.setOtpCode)(''));
        yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.OTP));
    }
}
function* handleToggleCloseTokenValidation({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
    }
    else {
        yield (0, effects_1.put)((0, login2FAAction_1.setLogin2faPopupData)({
            show: false,
            titleId: '',
            contentId: '',
            toggleTopRightCancel: () => { },
            footerType: '1',
            leftBtnLabelId: '',
            leftBtnCallback: () => { },
            rightBtnLabelId: '',
            rightBtnCallback: () => { }
        }));
        yield (0, effects_1.put)((0, login2FAAction_1.setOtpCode)(''));
        yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
    }
}
function* handleAuthorizationStatus() {
    console.log('handleAuthorizationStatus');
    // yield put(setAuthorizationStatusResult(AuthorizationStatusResult.SUCCESS));
    // TEMPORARY COMMENTED OUT TO BYPASS 2FA LOGIN, DO NOT COMMIT THIS TO BANK BITBUCKET
    yield (0, effects_1.delay)(4000);
    let triedCounts = 0;
    const MAX_TRY_COUNTS = 60;
    while (triedCounts < MAX_TRY_COUNTS) {
        triedCounts++;
        const { authorizationId, transactionId, refcode } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
        const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
        console.log(' handleAuthorizationStatus inputData', inputData);
        const params = {
            authorizationId,
            transactionId,
            txRef: refcode
        };
        const headers = {
            'x-acc-op': inputData.input.accessToken
        };
        const responseWrapper = yield (0, effects_1.call)(login2FAApi_1.apiTacAuthorizationStatusRetrieveWrapper, params, headers);
        if (responseWrapper.isError) {
            // continue
        }
        else if (responseWrapper.data.status === 'PENDING') {
            // continue
        }
        else if (responseWrapper.data.status === 'SUCCESS') {
            console.log('verify success');
            yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.SUCCESS));
            return;
        }
        else if (responseWrapper.data.status === 'FAILED') {
            // FAILED need to change to OTP screen
            console.log('verify failed');
            yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.FAILED));
            return;
        }
        yield (0, effects_1.delay)(3000);
    }
    // meaning tried too many times. turning to OTP screen
    console.error('exceed to max try counts !!');
    yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.MAX_TRY_COUNTS));
}
function* handleStartAuthorizationStatus() {
    const authorizationStatusTask = yield (0, effects_1.fork)(handleAuthorizationStatus);
    const interuptionActions = yield (0, effects_1.take)([login2FAAction_1.Login2FAType.END_AUTHORIZATION_STATUS, login2FAAction_1.Login2FAType.SET_AUTHORIZATION_STATUS_RESULT]);
    console.log('handleStartAuthorizationStatus, interuptionActions:', interuptionActions);
    yield (0, effects_1.cancel)(authorizationStatusTask);
}
function* handleSetAuthorizationStatusResult({ payload: authorizationStatusResult }) {
    console.log('handleSetAuthorizationStatusResult', authorizationStatusResult);
    switch (authorizationStatusResult) {
        case types_1.AuthorizationStatusResult.SUCCESS:
            yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.VERIFY_SUCCESS));
            yield (0, effects_1.delay)(2000);
            yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
            yield (0, effects_1.put)((0, login2FAAction_1.end2FAWorkFlowSuccessfully)());
            break;
        case types_1.AuthorizationStatusResult.FAILED:
            yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.OTP));
            break;
        case types_1.AuthorizationStatusResult.MAX_TRY_COUNTS:
            yield (0, effects_1.put)((0, login2FAAction_1.toggleGenerateOtp)());
            break;
    }
}
function* handleEndLogin2FAWorkflowSuccessfully() {
    console.log('login2fasaga: handleEndLogin2FAWorkflowSuccessfully');
    try {
        const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
        if (inputData && inputData.callback && typeof inputData.callback === 'function') {
            const callbackData = {
                result: 'succeed',
                data: {}
            };
            inputData.callback(callbackData);
        }
        else {
            console.error('error: no callback to mfe');
        }
    }
    catch (error) {
        console.error('handleEndLogin2FAWorkflowSuccessfully, error:', error);
    }
    yield (0, effects_1.put)((0, login2FAAction_1.end2FAWorkFlow)());
    yield;
}
function* handleCancelLogin2FAWorkflow(action) {
    console.log('login2fasaga, handleCancelLogin2FAWorkflow, input：', action);
    try {
        const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
        if (inputData && inputData.callback && typeof inputData.callback === 'function') {
            const callbackData = {
                result: 'failed',
                failedReason: action.payload,
                data: {}
            };
            inputData.callback(callbackData);
        }
        else {
            console.error('error: no callback to mfe');
        }
    }
    catch (error) {
        console.error('handleCancelLogin2FAWorkflow, error:', error);
    }
    yield (0, effects_1.put)((0, login2FAAction_1.end2FAWorkFlow)());
    yield;
}
function* login2FAWorkflow() {
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_CLOSE_ONE_TOKEN, handleToggleCloseOneToken);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_RESEND_NOTIFICATION, handleToggleResendNotification);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_GENERATE_OTP, handleToggleGenerateOtp);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_CLOSE_OTP, handleToggleCloseOtp);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_SUBMIT_OTP, handleToggleSubmitOtp);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_SUBMIT_HARDWARE_TOKEN, handleToggleSubmitHradWareToken);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_MOBILE_PHONE, handleToggleMobilePhone);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_CLOSE_INVALID, handleToggleCloseInvalid);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.TOGGLE_CLOSE_TOKEN_VALIDATION, handleToggleCloseTokenValidation);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.END_LOGIN_2FA_WORKFLOW_SUCCESSFULLY, handleEndLogin2FAWorkflowSuccessfully);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.CANCEL_LOGIN_2FA_WORKFLOW, handleCancelLogin2FAWorkflow);
    yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.SET_AUTHORIZATION_STATUS_RESULT, handleSetAuthorizationStatusResult);
    yield (0, effects_1.takeLatest)(login2FAAction_1.Login2FAType.START_AUTHORIZATION_STATUS, handleStartAuthorizationStatus);
    yield (0, effects_1.put)((0, login2FAAction_1.showLogin2FA)());
    const { inputData } = yield (0, effects_1.select)(login2FASelector_1.login2FASelector);
    if (inputData.input.tokenType === 'SWK') {
        //  softToken  ONE_TOKEN
        yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.ONE_TOKEN));
        //const { inputData } = yield select(login2FASelector)
        const params = {
            functionCode: '1FA-ELEVATION',
            triggerOTP: 'Yes',
            userId: inputData.input.userId,
            orgId: inputData.input.orgId,
            samlId: 'hardcode',
            actionBy: inputData.input.userId,
            isFirstTimeLogin: inputData.input.isFirstTimeLogin
        };
        console.log('login2FAWorkflow-inputData', inputData);
        const headers = {
            'x-acc-op': inputData.input.accessToken
        };
        const reqResponseWrapper = yield (0, effects_1.call)(login2FAApi_1.apiAccessElevationRequestWrapper, params, headers);
        console.log('IAccessElevation_ReqResponseWrapper_reqResponseWrapper', reqResponseWrapper);
        if (reqResponseWrapper.isError) {
            console.error('access request(no) failed');
            if (reqResponseWrapper.errorCode) {
                /*switch (reqResponseWrapper.errorCode) {
                    case ACCESS_ELEVATION_REQUEST_ERROR_CODE.TOKENVALIDATION:
                        yield put(setLayoutStatus(LayoutStatus.TOKEN_VALIDATION))
                        break
                    default:
                        yield put(dismissLogin2FA())
                        yield put(cancel2FAWorkFlow(WORKFLOW_CANCEL_REASON.API_ERROR))
                        break
                }*/
                if (reqResponseWrapper.errorCode === constants_1.ACCESS_ELEVATION_REQUEST_ERROR_CODE.TOKENVALIDATION) {
                    yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.TOKEN_VALIDATION));
                }
                else {
                    yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
                    yield (0, effects_1.put)((0, login2FAAction_1.cancel2FAWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.API_ERROR));
                }
            }
            else {
                yield (0, effects_1.put)((0, login2FAAction_1.dismissLogin2FA)());
                yield (0, effects_1.put)((0, login2FAAction_1.end2FAWorkFlow)());
            }
        }
        else {
            yield (0, effects_1.put)((0, login2FAAction_1.setMaskedMobileNo)(reqResponseWrapper.data.data.maskedMobileNo));
            yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationId)(reqResponseWrapper.data.data.authorizationId));
            yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationReference)(reqResponseWrapper.data.data.authorizationReference));
            yield (0, effects_1.put)((0, login2FAAction_1.setAuthorizationTypeCode)(reqResponseWrapper.data.data.authorizationTypeCode));
            yield (0, effects_1.put)((0, login2FAAction_1.setTransactionId)(reqResponseWrapper.data.data.transactionId));
            yield (0, effects_1.put)((0, login2FAAction_1.setRefcode)(reqResponseWrapper.data.data.refcode));
            yield (0, effects_1.put)((0, login2FAAction_1.startAuthorizationStatus)());
        }
    }
    else {
        // hardwardToken   HARD_WARE_TOKEN
        yield (0, effects_1.put)((0, login2FAAction_1.setLayoutStatus)(types_1.LayoutStatus.HARD_WARE_TOKEN));
    }
}
function* startLogin2FAWorkflow() {
    while (true) {
        const workflow = yield (0, effects_1.takeEvery)(login2FAAction_1.Login2FAType.START_LOGIN_2FA_WORKFLOW, login2FAWorkflow);
        // yield put(setIsLoading(false));
        yield (0, effects_1.take)(login2FAAction_1.Login2FAType.END_LOGIN_2FA_WORKFLOW);
        yield (0, effects_1.cancel)(workflow);
    }
}
const login2FASagas = [(0, effects_1.fork)(startLogin2FAWorkflow)];
exports.default = login2FASagas;
